import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import soundcloud from "../../Assets/Projects/soundcloud.png";
import jobhunter from "../../Assets/Projects/jobhunter.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={soundcloud}
              isBlog={false}
              title="Sound Cloud Clone"
              description="This project is a full-stack implementation of a Sound Cloud Clone, built using NestJS for the backend and Next.js for the frontend. This project provides a range of functionalities, including user authentication, track listening, playlist creation, track uploads, likes, follows, comments, and payment integration for account upgrades."
              ghLink="https://github.com/TranDatk/SoundCloudClone"
              demoLink="https://fe-next-js-sound-cloud-clone.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={jobhunter}
              isBlog={false}
              title="Job Hunter"
              description="The Job Hunter project is a full-stack application that helps job seekers find opportunities and employers manage job postings. It consists of a backend RESTful API built with Java Spring Boot and a frontend web application built with React and Vite."
              ghLink="https://github.com/TranDatk/Job-Hunter"
              demoLink="https://github.com/TranDatk/Job-Hunter"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
